const userRoles = {
    MENTOR: 'mentor',
    AUTHOR: 'author',
    STUDENT_PLUS: 'studentplus',
    EARLY_ACCESS: 'early-access',
    REGULAR_STUDENT: 'student',
    KQ_ADMIN: 'kq_admin',
    KQ_VOUCHER_MANAGER: 'kq_voucher_manager',
    INTERVENTION_AUTHOR: 'intervention_author',
    INTERVENTION_EDITOR: 'intervention_editor',
}

export const {
    MENTOR,
    AUTHOR,
    STUDENT_PLUS,
    EARLY_ACCESS,
    REGULAR_STUDENT,
    KQ_ADMIN,
    KQ_VOUCHER_MANAGER,
    INTERVENTION_AUTHOR,
    INTERVENTION_EDITOR,
} = userRoles

export default userRoles
